import React from 'react';
import styles from './signature.module.scss';

const Signature = ({
  signatures,
  signatureVisibility,
  handleSignatureUpload,
  handleSignatureVisibility,
  handleSignatureDelete,
  generateSignature,
  handleSaveSignatures,
  isSavingSignatures,
  formData,
  handleInputChange
}) => {
  return (
    <div className={styles.signatureContainer}>
      <h2>दस्तखत अपलोड</h2>
      
      <div className={styles.signatureSection}>
        {/* Section Officer Signature */}
        <div className={styles.signatureCard}>
          <h3>फण्टवालको दस्तखत</h3>
          <div className={styles.signatureContent}>
            {signatures.fontwalSignature ? (
              <div className={styles.signaturePreview}>
                <img 
                  src={signatures.fontwalSignature.preview} 
                  alt="Section Officer Signature"
                  className={signatureVisibility.fontwalSignature ? styles.visible : styles.hidden}
                />
                <div className={styles.signatureActions}>
                  <button 
                    onClick={() => handleSignatureVisibility('fontwalSignature')}
                    className={styles.toggleButton}
                  >
                    {signatureVisibility.fontwalSignature ? 'लुकाउनुहोस्' : 'हेर्नुहोस्'}
                  </button>
                  <button 
                    onClick={() => handleSignatureDelete('fontwalSignature')}
                    className={styles.deleteButton}
                  >
                    मेटाउनुहोस्
                  </button>
                </div>
              </div>
            ) : (
              <div className={styles.uploadSection}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleSignatureUpload('fontwalSignature', e.target.files[0])}
                  className={styles.fileInput}
                  id="fontwalSignature"
                />
                <label htmlFor="fontwalSignature" className={styles.uploadButton}>
                  फाइल छान्नुहोस्
                </label>
                <button 
                  onClick={() => generateSignature('fontwalSignature')}
                  className={styles.generateButton}
                >
                  दस्तखत सिर्जना गर्नुहोस्
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Store Chief Signature */}
        <div className={styles.signatureCard}>
          <h3>शाखा प्रमुखको दस्तखत</h3>
          <div className={styles.signatureContent}>
            {signatures.branchHeadSignature ? (
              <div className={styles.signaturePreview}>
                <img 
                  src={signatures.branchHeadSignature.preview} 
                  alt="Store Chief Signature"
                  className={signatureVisibility.branchHeadSignature ? styles.visible : styles.hidden}
                />
                <div className={styles.signatureActions}>
                  <button 
                    onClick={() => handleSignatureVisibility('branchHeadSignature')}
                    className={styles.toggleButton}
                  >
                    {signatureVisibility.branchHeadSignature ? 'लुकाउनुहोस्' : 'हेर्नुहोस्'}
                  </button>
                  <button 
                    onClick={() => handleSignatureDelete('branchHeadSignature')}
                    className={styles.deleteButton}
                  >
                    मेटाउनुहोस्
                  </button>
                </div>
              </div>
            ) : (
              <div className={styles.uploadSection}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleSignatureUpload('branchHeadSignature', e.target.files[0])}
                  className={styles.fileInput}
                  id="branchHeadSignature"
                />
                <label htmlFor="branchHeadSignature" className={styles.uploadButton}>
                  फाइल छान्नुहोस्
                </label>
                <button 
                  onClick={() => generateSignature('branchHeadSignature')}
                  className={styles.generateButton}
                >
                  दस्तखत सिर्जना गर्नुहोस्
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Certifying Officer Signature */}
        <div className={styles.signatureCard}>
          <h3>कार्यालय प्रमुखको दस्तखत</h3>
          <div className={styles.signatureContent}>
            {signatures.officeHeadSignature ? (
              <div className={styles.signaturePreview}>
                <img 
                  src={signatures.officeHeadSignature.preview} 
                  alt="Certifying Officer Signature"
                  className={signatureVisibility.officeHeadSignature ? styles.visible : styles.hidden}
                />
                <div className={styles.signatureActions}>
                  <button 
                    onClick={() => handleSignatureVisibility('officeHeadSignature')}
                    className={styles.toggleButton}
                  >
                    {signatureVisibility.officeHeadSignature ? 'लुकाउनुहोस्' : 'हेर्नुहोस्'}
                  </button>
                  <button 
                    onClick={() => handleSignatureDelete('officeHeadSignature')}
                    className={styles.deleteButton}
                  >
                    मेटाउनुहोस्
                  </button>
                </div>
              </div>
            ) : (
              <div className={styles.uploadSection}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleSignatureUpload('officeHeadSignature', e.target.files[0])}
                  className={styles.fileInput}
                  id="officeHeadSignature"
                />
                <label htmlFor="officeHeadSignature" className={styles.uploadButton}>
                  फाइल छान्नुहोस्
                </label>
                <button 
                  onClick={() => generateSignature('officeHeadSignature')}
                  className={styles.generateButton}
                >
                  दस्तखत सिर्जना गर्नुहोस्
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Save Signatures Button */}
      <div className={styles.saveSignaturesSection}>
        <button 
          onClick={handleSaveSignatures}
          disabled={isSavingSignatures}
          className={styles.saveSignaturesButton}
        >
          {isSavingSignatures ? 'दस्तखतहरू सेभ गर्दै...' : 'दस्तखतहरू सेभ गर्नुहोस् (फारम बनाउनुहोस्)'}
        </button>
        <p style={{ 
          textAlign: 'center', 
          marginTop: '10px', 
          fontSize: '14px', 
          color: '#666',
          fontFamily: 'Noto Sans Devanagari, Arial, sans-serif'
        }}>
          दस्तखतहरू सेभ गरेपछि मुख्य फाराममा क्लिक गरेर प्रयोग गर्न सकिन्छ
        </p>
      </div>
    </div>
  );
};

export default Signature;
